import Auth from '../auth';

const authHeaders = () => {
  const data = Auth.getAuthData();
  if (!data) return {};
  return {
    'access-token': data['access-token'],
    'token-type': data['token-type'],
    client: data.client,
    expiry: data.expiry,
    uid: data.uid,
  };
};

const request = async (accountId, path, options = {}) => {
  const response = await fetch(
    `/api/v1/accounts/${accountId}/aceleres/funil_configuration${path}`,
    {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        ...authHeaders(),
        ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      },
      ...options,
    }
  );
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false)
    throw new Error(data.message || 'Não foi possível salvar a configuração.');
  return data;
};

export const fetchFunnelConfiguration = accountId => request(accountId, '');
export const updateFunnelConfiguration = (accountId, funnelId, payload) =>
  request(accountId, `/funnels/${funnelId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
export const updateStageConfiguration = (accountId, stageId, payload) =>
  request(accountId, `/stages/${stageId}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
